import React, { useRef, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import { Navigation, Snackbar } from 'common';
import SemanticMatchForm from './semanticMatchForm';
import TalentList from './talentList';
import { useSelector } from 'react-redux';
import SrPageBanner from 'core/srPageBanner/srPageBanner';
import { IMG_MAN_WORKING } from 'images';
import ExplainableMatchForm from './explainableMatchForm';
import FormTabs from './formTabs';
import ExplainableMatchCard from './explainableMatchCard';
import TalentListEmpty from './talentListEmpty';

const useStyles = makeStyles(() => ({
  container: {
    padding: 24,
    background: '#fbfbfb',
    position: 'relative',
    marginTop: 26,
    minHeight: 'calc(100vh - 48px)',
    alignContent: 'flex-start',
  },
  bannerClass: {
    marginTop: 24,

    '& div': {
      maxWidth: 600,
    },
  },
  rightContent: {
    paddingLeft: 25,
  },
}));

const TalentAiMatching = () => {
  const classes = useStyles();
  const [talentList, setTalentList] = useState([]);
  const bannerRef = useRef(null);
  const [selectedScreen, setSelectedScreen] = useState(
    'BI_METRIC_SEMANTIC_MATCH_SCREEN'
  );
  const { TalentAiFileTypeError, TalentAiMultipleFilesError } = useSelector(
    (state) => state.flags
  );

  const updateCredits = () => {
    if (bannerRef.current) {
      bannerRef.current.getCreditCount();
    }
  };

  const CONTENT_MAP = {
    BI_METRIC_SEMANTIC_MATCH_SCREEN: {
      title: 'Bi-Metric Semantic Match',
      subTitle:
        'Leverage Bi-Metric Matching for high volume job - talent any-directional matching. Based on Language vectors fine-tuned on billions of Jobs and Talent data points.',
      planId: '60abf7991de5ad1d029f0dc7',
      apiLink: 'https://docs.senseloaf.ai/#tag/Semantic-AI-Matching',
    },
    EXPLAINABLE_MATCH_SCREEN: {
      title: 'Explainable Match',
      subTitle:
        'AI to match and evaluate jobs-candidates on factors like skills, experience and job-titles individually. Based on Language vectors file-tuned on billions of Jobs and Talent data points.',
      planId: '64734033b14b2f2890d5092c',
      apiLink: 'https://docs.senseloaf.ai/#tag/Explainable-Match',
    },
  };

  return (
    <>
      <Navigation />
      <Grid container classes={{ root: classes.container }}>
        <Grid container classes={{ root: classes.contentContainer }}>
          <Grid item xs={5}>
            <FormTabs
              selectedScreen={selectedScreen}
              setSelectedScreen={setSelectedScreen}
              resetContent={() => setTalentList([])}
            />
            {selectedScreen === 'BI_METRIC_SEMANTIC_MATCH_SCREEN' ? (
              <SemanticMatchForm
                setTalentList={setTalentList}
                talentList={talentList}
                updateCredits={updateCredits}
              />
            ) : (
              <ExplainableMatchForm
                setTalentList={setTalentList}
                talentList={talentList}
                updateCredits={updateCredits}
              />
            )}
          </Grid>

          <Grid item xs={7} classes={{ root: classes.rightContent }}>
            <SrPageBanner
              title={CONTENT_MAP[selectedScreen].title}
              subTitle={CONTENT_MAP[selectedScreen].subTitle}
              image={IMG_MAN_WORKING}
              containerClass={classes.bannerClass}
              planId={CONTENT_MAP[selectedScreen].planId}
              apiLink={CONTENT_MAP[selectedScreen].apiLink}
              bannerRef={bannerRef}
            />
            {selectedScreen === 'BI_METRIC_SEMANTIC_MATCH_SCREEN' ? (
              <TalentList list={talentList} />
            ) : talentList.length ? (
              <div style={{ height: 'calc(100vh - 275px)', overflowY: 'auto' }}>
                {talentList.map((talent) => (
                  <ExplainableMatchCard talent={talent} />
                ))}
              </div>
            ) : (
              <TalentListEmpty />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Snackbar
        open={TalentAiFileTypeError}
        message={'Accepts only pdf, doc, docx, txt and zip files'}
        flag="TalentAiFileTypeError"
      />
      <Snackbar
        open={TalentAiMultipleFilesError}
        message={'Multiple Files are not allowed for JD'}
        flag="TalentAiMultipleFilesError"
      />
    </>
  );
};

export default TalentAiMatching;
